"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.languageCookieName = exports.languageDefault = exports.languageList = void 0;
const config_1 = __importDefault(require("next/config"));
const { publicRuntimeConfig = {} } = (0, config_1.default)();
const { languagesString = process.env.LANGUAGES_STRING || 'en', languageDefault = process.env.LANGUAGE_DEFAULT || `en`, languageCookieName = process.env.LANGUAGE_COOKIE_NAME || `NEXT_LOCALE`, } = publicRuntimeConfig;
exports.languageDefault = languageDefault;
exports.languageCookieName = languageCookieName;
const languageList = languagesString.split(',');
exports.languageList = languageList;
//# sourceMappingURL=language.constants.js.map